import { useQuery } from '@tanstack/react-query';
import { connectService } from 'v2/services/connect';

export const useListTriggers = () => {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['connect', 'triggers'],
    queryFn: () => connectService.listTriggers()
  });

  return { triggers: data?.data ?? [], isLoading, error, refetch };
};
